import error from "@/core/middlewares/error";

let pageNotFound = () => import(/* webpackChunkName: "errors" */ '@/views/errors/PageNotFound');
let internalServerError = () => import(/* webpackChunkName: "errors" */ '@/views/errors/InternalServerError');
let banned = () => import(/* webpackChunkName: "errors" */ '@/views/errors/Banned');
let forbidden = () => import(/* webpackChunkName: "errors" */ '@/views/errors/Forbidden');
let unavailable = () => import(/* webpackChunkName: "errors" */ '@/views/errors/Unavailable');


export default [
    {
        path: "/errors",
        redirect: "/errors/404",
        component: () => import("@/views/errors/Layout"),
        children: [
            {
                path: "banned",
                name: "errors.banned",
                component: banned,
                meta: {
                    title: "مسدود"
                }
            },
            {
                path: "forbidden",
                name: "errors.forbidden",
                component: forbidden,
                meta: {
                    title: '403',
                    middleware: error,
                    code: 403
                }
            },
            {
                path: "server",
                name: "errors.internal_server_error",
                component: internalServerError,
                meta: {
                    title: '500',
                    middleware: error,
                    code: 500
                }
            },
            {
                path: "unavailable",
                name: "errors.unavailable",
                component: unavailable,
                meta: {
                    title: '503',
                    middleware: error,
                    code: 503
                }
            },
        ]
    },
    {
        path: "*",
        name: "errors.not_found",
        component: pageNotFound,
        meta: {
            title: '404',
        }
    },
]
